import React, { useState } from 'react'
import "./style.css"
import List from "./List.jsx"
import Add from "./Add.jsx"

const ServiceArea = (p) => {

  const [editableData, setEditableData] = useState(null);

  const props = {
    ...p,
    setEditableData,
    editableData
  }

  return (
    <div className='service_area'>
      <div className='add-area'>
        <Add {...props} />
      </div>
      <div className='area-list'>
        <List  {...props} />
      </div>
    </div>
  )
}

export default ServiceArea



